import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/common";

export function ProtectedRoute({ children, admin = false }) {
  const { user, checked, reconnecting, retryNow } = useAuth();
  if (reconnecting && user === null) return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50" data-testid="session-reconnecting">
      <Spinner label="Reconnecting… your session is safe" />
      <button onClick={retryNow} className="rounded-md border border-slate-300 px-4 py-2 text-sm font-medium text-[#0B132B] hover:bg-white" data-testid="session-retry-btn">Retry now</button>
    </div>
  );
  if (!checked || user === null) return <div className="min-h-screen bg-slate-50"><Spinner label="Checking session" /></div>;
  if (!user) return <Navigate to={admin ? "/admin/login" : "/login"} replace />;
  const isAdmin = ["SUPPORT", "OPERATIONS", "ADMIN", "SUPER_ADMIN", "VIEW_ONLY", "LIMITED"].includes(user.role);
  if (admin && !isAdmin) return <Navigate to="/dashboard" replace />;
  if (!admin && isAdmin) return <Navigate to="/admin/dashboard" replace />;
  return children;
}
